import {
  EQUIPMENT_STOCK_DETAIL_LIST, 
  EQUIPMENT_STOCK_DETAIL_LIST_SUCCESS, 
  EQUIPMENT_STOCK_DETAIL_LIST_ERROR,
  EQUIPMENT_STOCK_DETAIL_SEARCH_SET, 
  EQUIPMENT_STOCK_DETAIL_SEARCH_CHANGE, 
  EQUIPMENT_STOCK_DETAIL_PAGE_SET,
  EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK,
  EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_ERROR,
  EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION,
  EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_ERROR, 
  EQUIPMENT_STOCK_DETAIL_ADD_SET,
  EQUIPMENT_STOCK_DETAIL_ADD_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_ADD,
  EQUIPMENT_STOCK_DETAIL_ADD_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ADD_ERROR,
  EQUIPMENT_STOCK_DETAIL_ADD_CHANGE,
  EQUIPMENT_STOCK_DETAIL_DETAIL,
  EQUIPMENT_STOCK_DETAIL_DETAIL_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_DETAIL_ERROR,
  EQUIPMENT_STOCK_DETAIL_VIEW_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_EDIT_CHANGE,
  EQUIPMENT_STOCK_DETAIL_EDIT_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_UPDATE,
  EQUIPMENT_STOCK_DETAIL_UPDATE_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_UPDATE_ERROR,
  EQUIPMENT_STOCK_DETAIL_VIEW_TAB_SET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 1000
    }
  },
  add: {
    data: {
      new:{ id_apply_option: null, apply_option: null, notes: ''}
    },
    modal: false,
    loading: false,
    message: '',
    url: '',
    type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      equipment_stock: false,
      apply_option: false,
    },
    value:{
      equipment_stock: false,
      apply_option: false,
    },
    equipment_stock:{
      loading: true,
      list:[],
      message: ''
    },
    apply_option:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case EQUIPMENT_STOCK_DETAIL_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case EQUIPMENT_STOCK_DETAIL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case EQUIPMENT_STOCK_DETAIL_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case EQUIPMENT_STOCK_DETAIL_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case EQUIPMENT_STOCK_DETAIL_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case EQUIPMENT_STOCK_DETAIL_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          equipment_stock:{
            ...state.search.equipment_stock,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          equipment_stock:{
            ...state.search.equipment_stock,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          equipment_stock:{
            ...state.search.equipment_stock,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          apply_option:{
            ...state.search.apply_option,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          apply_option:{
            ...state.search.apply_option,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          apply_option:{
            ...state.search.apply_option,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { id_equipment_stock: null, equipment_stock: null, id_apply_option: null, apply_option: null, notes: '' }
          },
          modal: action.payload
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case EQUIPMENT_STOCK_DETAIL_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true
        }
      }
    case EQUIPMENT_STOCK_DETAIL_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false
        }
      }
    case EQUIPMENT_STOCK_DETAIL_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case EQUIPMENT_STOCK_DETAIL_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case EQUIPMENT_STOCK_DETAIL_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case EQUIPMENT_STOCK_DETAIL_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    default:
      return { ...state };
    }

};